<template>
  <component :is="component" v-bind="props">
    <slot />
  </component>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';
import type { NuxtLinkProps } from '#app';

export interface ButtonBaseProps extends NuxtLinkProps {
  to?: string | RouteLocationRaw;
  type?: 'button' | 'submit' | 'reset';
}

const props = defineProps({
  to: null,
  type: { default: 'button' }
});

const component = computed(() => {
  if (props.to || props.href) {
    return resolveComponent('NuxtLink');
  }
  return 'button';
});
</script>
<style lang="scss" scoped></style>
